// index.js
// React entry point
// - Mounts <App /> to #root
// - Hides the initial HTML loader from index.html
// - Initializes i18n

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Initialize i18next

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hide the initial HTML loader (defined in index.html)
if (window.__MADAD_HIDE_LOADER__) {
  window.__MADAD_HIDE_LOADER__();
}
